import styled from 'styled-components';

export const ResultsList = styled.div`
  overflow-y: auto;
  overflow-y: overlay;
  padding: 1rem 2rem;
  > div {
    margin-bottom: 1rem;
  }
`;
